const PROFILE_KEY = 'onlyfindz-marketplace-profile-v1';
const intelligenceState = window.__OnlyFindzMarketplaceIntelligenceState || (window.__OnlyFindzMarketplaceIntelligenceState = {
  lastTrackedHandle: '',
  lastTrackedAt: 0
});

function visitorAllowsPersonalization() {
  const consent = window.OnlyFindzConsent && typeof window.OnlyFindzConsent.get === 'function'
    ? window.OnlyFindzConsent.get()
    : null;

  return Boolean(consent && consent.preferences);
}

function safeParseProfile() {
  try {
    const raw = window.localStorage.getItem(PROFILE_KEY);
    if (!raw) return { products: [], vendors: {}, categories: {} };
    const parsed = JSON.parse(raw);
    return {
      products: Array.isArray(parsed.products)
        ? parsed.products
        : Array.isArray(parsed.recentProducts)
          ? parsed.recentProducts
          : [],
      vendors:
        parsed.vendors && typeof parsed.vendors === 'object'
          ? parsed.vendors
          : parsed.vendorScores && typeof parsed.vendorScores === 'object'
            ? parsed.vendorScores
            : {},
      categories:
        parsed.categories && typeof parsed.categories === 'object'
          ? parsed.categories
          : parsed.categoryScores && typeof parsed.categoryScores === 'object'
            ? parsed.categoryScores
            : {},
    };
  } catch (_) {
    return { products: [], vendors: {}, categories: {} };
  }
}

function saveProfile(profile) {
  if (!visitorAllowsPersonalization()) return;
  window.localStorage.setItem(PROFILE_KEY, JSON.stringify(profile));
}

function clearProfile() {
  try {
    window.localStorage.removeItem(PROFILE_KEY);
  } catch (_) {}
}

function bumpScore(map, key, amount = 1) {
  if (!key) return;
  map[key] = (map[key] || 0) + amount;
}

function trackViewedProduct() {
  if (!visitorAllowsPersonalization()) return;

  const productRoot = document.querySelector('[data-marketplace-product]');
  if (!productRoot) return;

  const handle = productRoot.dataset.productHandle;
  if (!handle) return;
  if (productRoot.dataset.onlyfindzIntelligenceTracked === 'true') return;

  const now = Date.now();
  if (intelligenceState.lastTrackedHandle === handle && now - intelligenceState.lastTrackedAt < 1500) {
    productRoot.dataset.onlyfindzIntelligenceTracked = 'true';
    return;
  }

  const vendor = (productRoot.dataset.productVendor || '').trim();
  const category = (productRoot.dataset.productCategory || '').trim();

  const profile = safeParseProfile();
  profile.products = [handle, ...profile.products.filter((item) => item !== handle)].slice(0, 24);
  bumpScore(profile.vendors, vendor, 2);
  bumpScore(profile.categories, category, 3);
  saveProfile(profile);
  intelligenceState.lastTrackedHandle = handle;
  intelligenceState.lastTrackedAt = now;
  productRoot.dataset.onlyfindzIntelligenceTracked = 'true';
}

function bootstrapMarketplaceIntelligence() {
  if (!visitorAllowsPersonalization()) {
    clearProfile();
    return;
  }

  trackViewedProduct();
}

document.addEventListener('DOMContentLoaded', bootstrapMarketplaceIntelligence);
document.addEventListener('shopify:section:load', bootstrapMarketplaceIntelligence);
window.addEventListener('onlyfindz:consent-updated', bootstrapMarketplaceIntelligence);
